import React from "react";
import styles from "./TrustSection.module.css";

const trustItems = [
    {
        id: 1,
        icon: "/images/verify.svg",
        title: "Verified Vendors",
        description: "Every professional is vetted and background-checked.",
    },
    {
        id: 2,
        icon: "/images/tag.svg",
        title: "Transparent Pricing",
        description: "Clear pricing with no hidden fees or surprises.",
    },
    {
        id: 3,
        icon: "/images/check.svg",
        title: "SLA Tracking",
        description: "Real-time tracking and guaranteed delivery timelines.",
    },
    {
        id: 4,
        icon: "/images/lock.svg",
        title: "Secure Payments",
        description: "Your transactions are encrypted and fully protected.",
    },
];

function TrustSection() {
    return (
        <section className={styles.section}>

            <div className={styles.heading}>
                <h2>Built on Trust & Reliability</h2>
                <p>We ensure every interaction on our platform meets the highest standards.</p>
            </div>

            <div className={styles.grid}>
                {trustItems.map((item) => (
                    <div key={item.id} className={styles.card}>
                        <div className={styles.iconWrap}>
                            <img src={item.icon} alt={item.title} />
                        </div>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>

        </section>
    );
}

export default TrustSection;